// extracted by mini-css-extract-plugin
export default {"overlay":"Loading_overlay__UcbEs","animalsLine":"Loading_animalsLine__YOnkq","animalImage":"Loading_animalImage__efy+q"};